import {getPlans} from "../../services/plans.service";
import {subscribeToKidjo} from "../../services/subscriptions.v2.services";

const state = {
    userPlan: [],
    selectedTypePlans: [],
    currentPlanType: '',
    currentSelectedPlan: {},
    currentSelectedPlans: [],
    changePlan: {},
    plans: [
        {
            product: "kidjo_tv_books_games",
            planId: "plan_select_yearly_title",
            iap: "default_one_yearly",
            price: 49.90,
            promoTitle: "plan_select_yearly_promo_text",
            nameKey: "annual_plan",
            durationCode: "P1Y",
            currencySymbol: '$',
            subTitle: null,
            status: true,
            addOns: [
                {
                    addonName: "default_three_yearly",
                    price: 20
                }
            ]
        },
        {
            product: "kidjo_tv_books_games",
            planId: "plan_select_monthly_title",
            price: 7.99,
            promoTitle: null,
            subTitle: "register_page_box_subtitle",
            nameKey: "monthly_plan",
            durationCode: "P1M",
            currencySymbol: '$',
            status: true,
            iap: "default_one",
            addOns:[
                {
                    addonName: "default_three",
                    price: 3
                }
            ]
        },
    ]
}

const getters = {
    getAnnualPlan(state){
        return state.plans.find(obj => obj.durationCode === 'P1Y');
    },
    getAllPlans(state){
        return state.plans;
    },
    getMonthlyPlan(state) {
        return state.plans.find(obj => obj.durationCode === 'P1M');
    },
    getUserPlans(state) {
        return state.userPlan
    },
    getSelectedPlans(state) {
        return state.selectedTypePlans
    },
    getCurrentPlanType(state) {
        return state.currentPlanType
    },
    getCurrentSelectedPlan(state) {
        if (Object.keys(state.currentSelectedPlan).length > 0) {
            return state.currentSelectedPlan;
        } else if(localStorage.getItem('plan') === 'P1M') {
            return  state.plans.find(obj => obj.durationCode === 'P1M');
        }
        return  state.plans.find(obj => obj.durationCode === 'P1Y');
    },
    getCurrentSelectedPlans(state) {
        return state.currentSelectedPlans
    },

    getShowCurrentPlanSelected(state) {
        return state.changePlan.showAll
    }
}

const actions = {
    async getUserEligiblePlans({commit, getters}, data) {
        await getPlans({showAll: data.showAll, countryCode: data.countryCode}).then(response => {
            commit('setShowCurrentPlan', {showAll: data.showAll})
            commit('setPlans', {userPlan: response.data})
            commit('setCurrentPlanType', 'monthly_plan')
            commit('setSelectedPlans', response.data.find(plan => plan.nameKey === 'monthly_plan').plans);

            const discounts = JSON.parse(localStorage.getItem("discountDetails"));

            // All selected plans
            if (data.showAll) {
                response.data
                    .find(plan => plan.nameKey === 'monthly_plan')
                    .plans
                    .filter(p => p.subscribed)
                    .forEach((plan) => {
                        commit('setCurrentSelectedPlans', plan)
                    });
                commit('setPlanMonthly', response.data.find(plan => plan.nameKey === 'monthly_plan').plans);
                commit('setPlanAnnual', response.data.find(plan => plan.nameKey === 'annual_plan').plans);
            } else if (discounts != null && discounts.isBundleDiscount) {
                commit('setCurrentSelectedPlans', response.data.find(plan => plan.nameKey === 'monthly_plan').plans[0])
                commit('setCurrentSelectedPlans', response.data.find(plan => plan.nameKey === 'monthly_plan').plans[1])
            } else {
                commit('setPlanMonthly', response.data.find(plan => plan.nameKey === 'monthly_plan').plans);
                commit('setPlanAnnual', response.data.find(plan => plan.nameKey === 'annual_plan').plans);
                commit('setCurrentSelectedPlans', response.data.find(plan => plan.nameKey === 'monthly_plan').plans[0])
            }
        }).catch(error => {
            console.log(error);
        });
    },

    async subscribe({commit}, data) {
        return subscribeToKidjo(data);
    }
}

const mutations = {
    setPlanAnnual(state, plans) {
        state.plans = state.plans.map(plan => {
           if (plan.durationCode === "P1Y") {
                return {
                    ...plan,
                    iap:  plans[0].iap,
                    price: parseFloat(plans[0].price + plans[0].addOns.filter(addon => addon.addonName.includes("_three_yearly"))[0].price),
                    currencySymbol: plans[0].currencySymbol,
                    currency: plans[0].currency,
                    addOns: plans[0].addOns.filter(addon => addon.addonName.includes("_three_yearly"))
                };
            }
            return plan;
        });
    },
    setPlanMonthly(state, plans) {
        state.plans = state.plans.map(plan => {
           if (plan.durationCode === "P1M") {
                return {
                    ...plan,
                    iap:  plans[0].iap,
                    price: parseFloat(plans[0].price + plans[0].addOns.filter(addon => addon.addonName.includes("_three"))[0].price),
                    currencySymbol: plans[0].currencySymbol,
                    currency: plans[0].currency,
                    addOns: plans[0].addOns.filter(addon => addon.addonName.includes("_three"))
                };
            }
            return plan;
        });
    },
    setPlans(state, allPlans) {
        state.userPlan = allPlans;
    },

    setSelectedPlans(state, plan) {
        state.selectedTypePlans = plan;
    },

    setCurrentPlanType(state, planType) {
        state.currentPlanType = planType;
    },

    resetCurrentSelectedPlans(state) {
        state.currentSelectedPlans = [];
    },
    removeCurrentSelectedPlan(state) {
        state.currentSelectedPlan = {}
    },
    removeFromSelectedPlan(state, plan) {
        const indexToRemove = state.currentSelectedPlans.findIndex(current => current.product === plan.product);
        state.currentSelectedPlans.splice(indexToRemove, 1);
    },

    setCurrentSelectedPlan(state, plan) {
        state.currentSelectedPlan = { ...plan };
    },
    setCurrentSelectedPlans(state, plans) {
        state.currentSelectedPlans.push(plans);
    },
    setShowCurrentPlan(state, plans) {
        state.changePlan = plans
    }


}

export default {
    state,
    getters,
    actions,
    mutations
};
